import React from 'react';

import { SquareBorderButton } from '@lyearn-team/frontend-components';

import ImperativePopup from 'components/ImperativePopup';
import * as s from './styles';

const UserTakeControlPopup = ({ onCancel }) => {
  function handleTakeControl() {
    onCancel('OK');
  }

  return (
    <React.Fragment>
      <div className={s.imageWrapper}>
        <img src={window.constants.imageUrl + 'multiple_tabs.png'} alt="" />
      </div>
      <div className={s.mainText}>
        You’ve more than one Lyearn App page active in the browser(s). Please click &quot;
        <strong>Take control</strong>
        &quot; to sync progress of this page.
      </div>
      <div className={s.buttonWrapper}>
        <SquareBorderButton text="Take Control" onClick={handleTakeControl} type="filled" />
      </div>
    </React.Fragment>
  );
};

export default function showUserTakeControl() {
  return ImperativePopup.show(({ onCancel }) => {
    function handleClose() {
      onCancel('CANCEL');
    }

    return {
      props: {
        showPopup: true,
        header: null,
        onCloseClick: handleClose,
        onOverlayClick: handleClose,
        popupClassName: s.popup,
        stickyHeader: true,
        withPortal: true,
        popupWrapperZIndex: 10001
      },
      children: <UserTakeControlPopup onCancel={onCancel} />
    };
  });
}
